
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 21,
  viewBox: "0 0 12 21",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m3.621 10.5 7.94-7.94A1.5 1.5 0 0 0 9.439.44l-9 9a1.5 1.5 0 0 0 0 2.12l9 9a1.5 1.5 0 0 0 2.122-2.12L3.62 10.5Z",
  fill: "#3d3c3d",
  fillRule: "nonzero",
  stroke: "#000",
  strokeWidth: 1.5
})));

      const __svgRaw = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg width=\"12px\" height=\"21px\" viewBox=\"0 0 12 21\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>FE5FD1F0-4135-457B-B28F-DBE5FA6B9E68</title>\r\n    <g id=\"Symbols\" stroke=\"black\" stroke-width=\"1.5\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"icons/back\" fill=\"#3d3c3d\" fill-rule=\"nonzero\">\r\n            <path d=\"M3.62132034,10.5 L11.5606602,2.56066017 C12.1464466,1.97487373 12.1464466,1.02512627 11.5606602,0.439339828 C10.9748737,-0.146446609 10.0251263,-0.146446609 9.43933983,0.439339828 L0.439339828,9.43933983 C-0.146446609,10.0251263 -0.146446609,10.9748737 0.439339828,11.5606602 L9.43933983,20.5606602 C10.0251263,21.1464466 10.9748737,21.1464466 11.5606602,20.5606602 C12.1464466,19.9748737 12.1464466,19.0251263 11.5606602,18.4393398 L3.62132034,10.5 Z\"></path>\r\n        </g>\r\n    </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrow.63e7e0a193ed84a34a454c10d1203b76.svg"),
        {
          React: SvgArrow,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      